export default __webpack_public_path__ + "static/media/sticker-G.53f1a99f.png";